import { add, format, sub } from 'date-fns';

import { forceLocalDate } from '../../utils/dates';
import { ForecastKind, ForecastType, NewForecastDataSource } from './types';
import { trackEvent } from '../../core/tracker';
import { TRACKING_EVENTS } from '../../core/constants';

/**
 * Returns the ForecastKind for the given budget-related data source
 * @param dataSource - Forecast data source
 */
export const getBudgetForecastKind = (dataSource: NewForecastDataSource) => {
  if (dataSource === NewForecastDataSource.FromScratch || dataSource === NewForecastDataSource.WithAutoPredictions) {
    return ForecastKind.BUDGET_FROM_SCRATCH;
  }
  if (dataSource === NewForecastDataSource.FromLYA) {
    return ForecastKind.BUDGET_FROM_ACTUALS;
  }
  return ForecastKind.BUDGET_FROM_EXISTING;
};

/**
 * Returns the ForecastKind for the given scenario-related data source
 * @param dataSource - Forecast data source
 */
export const getScenarioForecastKind = (dataSource: NewForecastDataSource) => {
  if (dataSource === NewForecastDataSource.FromScratch || dataSource === NewForecastDataSource.WithAutoPredictions) {
    return ForecastKind.SCENARIO_FROM_SCRATCH;
  }
  if (dataSource === NewForecastDataSource.FromLYA) {
    return ForecastKind.SCENARIO_FROM_ACTUALS;
  }
  return ForecastKind.SCENARIO_FROM_EXISTING;
};

/**
 * Sends a forecast creation tracking event
 * @param forecastType - the type of the new forecast (E.G: budget)
 */
export const trackCreateForecastEvent = (forecastType?: ForecastType, isConsolidated?: boolean) => {
  if (!forecastType) {
    return;
  }

  trackEvent(TRACKING_EVENTS.CREATED_ANY_FORECAST);

  if (isConsolidated) {
    trackEvent(TRACKING_EVENTS.CREATE_CONSOLIDATION_FORECAST);
  } else {
    if (forecastType === ForecastType.BUDGET) {
      trackEvent(TRACKING_EVENTS.CREATED_1_YR_P_L);
    }
    if (forecastType === ForecastType.SCENARIO) {
      trackEvent(TRACKING_EVENTS.CREATED_3_YR_CASH_FLOW);
    }
    if (forecastType === ForecastType.SCENARIO_WITH_INVOICES) {
      trackEvent(TRACKING_EVENTS.CREATED_3_YR_CASH_FLOW_INVOICES);
    }
  }
};

export const getBudgetDateRange = (fromDate: string) => {
  const startDate = forceLocalDate(fromDate);
  const startDateFormatted = format(startDate, 'dd MMM yyyy');
  const endDate = sub(add(startDate, { years: 1 }), { days: 1 });
  const endDateFormatted = format(endDate, 'dd MMM yyyy');

  return `${startDateFormatted} - ${endDateFormatted}`;
};
